module.exports = __webpack_public_path__ + "img/ky.ky8201984.svg";